



















































import { Component, Vue, Mixins } from "vue-property-decorator";
import MyList from "@/mixins/list";
import Add from "./Add.vue";
import Edit from "./Edit.vue";

@Component({
  components: {
    Add,
    Edit,
  },
})
export default class extends Mixins(MyList) {
  dispatchType = "setting/getList";

  dispatchTypeDelete = "setting/delete";

  deleteConfirmContent = "确认要删除该配置吗？";

  columns: any[] = [
    {
      title: "编号",
      width: 100,
      dataIndex: "id",
    },
    {
      title: "适用用户类型",
      width: 100,
      scopedSlots: { customRender: "user_type" },
    },
    {
      title: "用户客户端",
      width: 100,
      scopedSlots: { customRender: "client_type" },
    },
    {
      title: "设定类型",
      width: 100,
      dataIndex: "setting_type",
    },
    {
      title: "设定代码",
      width: 200,
      dataIndex: "code",
    },
    {
      title: "描述",
      scopedSlots: { customRender: "description" },
    },
    {
      title: "状态",
      width: 100,
      scopedSlots: { customRender: "status" },
    },
    {
      title: "设定规则",
      width: 150,
      scopedSlots: { customRender: "setting_rule" },
    },
    {
      title: "操作",
      width: 150,
      scopedSlots: { customRender: "action" },
    },
  ];

  async loadData1() {
    this.loading = true;
    const res = await this.$store.dispatch(this.dispatchType, {});
    if (res && res.Message === "success") {
      this.data = res.Data;
    }
    this.loading = false;
  }

  hideAddModal1() {
    this.addModalVisible = false;
    this.loadData1();
  }

  hideEditModal1() {
    this.editModalVisible = false;
    this.loadData1();
  }

  handleDelete1(id: number) {
    this.showTsConfirm({
      title: this.deleteConfirmTitle,
      content: this.deleteConfirmContent,
      onOk: async () => {
        const res = await this.$store.dispatch(this.dispatchTypeDelete, {
          id,
        });
        if (res && res.Message === "success") {
          this.$message.success(res.Message);
          this.loadData1();
        } else {
          this.$message.error(res.Message);
        }
      },
      onCancel() {
        // alert('cancel')
      },
    });
  }

  mounted() {
    this.loadData1();
  }
}
